<div id="style-2" [ngStyle]="{ 'max-height': customHeight, overflow: 'auto' }">
  <table mat-table [dataSource]="datasource" [ngClass]="class">
    <ng-container
      [matColumnDef]="column.ColumnDef"
      *ngFor="
        let column of displayedColumns;
        let i = index;
        trackBy: trackByIndex
      "
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        [ngStyle]="{ width: column.size ? column.size : 'auto' }"
        [ngClass]="[
          column.IconAlign
            ? column.IconAlign
            : column.TextAlign
            ? column.TextAlign
            : column.Pipe == pipe.UFPipe ||
              column.Pipe == pipe.thousandPipe ||
              column.Pipe == pipe.currencyCLPipe ||
              column.Pipe == pipe.decimalPipe ||
              column.Pipe == pipe.checkNumberPipe ||
              column.Pipe == pipe.percentagePipe ||
              column.Pipe == pipe.purePercentagePipe ||
              column.Icon
            ? 'mat-cell-right'
            : column.Pipe == pipe.datePipe
            ? 'mat-cell-center'
            : 'mat-cell-left',
          theme === 0 ? 'mat-header-cell-dark' : 'mat-header-cell-light'
        ]"
      >
        <mat-checkbox
          [(ngModel)]="checkedAll"
          (change)="onChangeCheckboxAll($event)"
          *ngIf="column.CheckBox"
        >
        </mat-checkbox>
        {{ !column.CheckBox ? column.ColumnName : '' }}
      </th>
      <span *ngIf="column.Icon">
        <td
          mat-cell
          appTableCellFormat
          [ngStyle]="{ width: column.size ? column.size : 'auto' }"
          style="padding-top: 0.3rem !important; padding-bottom: 0.3rem !important;"
          [column]="column"
          *matCellDef="let element"
        >
          <div
            [ngClass]="column.IconAlign ? column.IconAlign : 'mat-cell-right'"
          >
            <a *ngIf="(showUF2 && isApvSelect) || !isApvSelect" (click)="onIconClick(element, column.ColumnDef)">
              <mat-icon
                *ngIf="
                  !column.SvgIcon &&
                  column.ColumnDef &&
                  !element[column.ColumnDef] &&
                  !element['hideIcon']
                "
                >{{ column.ColumnDef }}</mat-icon
              >
              <svg-icon
                *ngIf="column.SvgIcon && !element['hideSvg']"
                src="../../../assets/icons/{{ column.ColumnDef }}"
                [svgStyle]="{
                  'width.rem': 1.5
                }"
              ></svg-icon>
            </a>
          </div>
        </td>
      </span>
      <span *ngIf="column.CheckBox">
        <td
          mat-cell
          appTableCellFormat
          [ngStyle]="{ width: column.size ? column.size : 'auto' }"
          [column]="column"
          *matCellDef="let element"
        >
          <mat-checkbox
            *ngIf="element"
            [(ngModel)]="element.Checked"
            (change)="onChangeCheckboxItem($event, element)"
          >
          </mat-checkbox>
        </td>
      </span>
      <span *ngIf="!column.Icon && !column.CheckBox">
        <td
          mat-cell
          appTableCellFormat
          [column]="column"
          [element]="element"
          *matCellDef="let element"
          [ngClass]="[
            column.TextAlign ? column.TextAlign : '',
            column.TextStyle ? column.TextStyle : ''
          ]"
          [ngStyle]="{
            color: column.Color
              ? column.Color
              : hasRowCheckBox && element.Checked
              ? '#ed6e00'
              : column.TextStyle == 'mat-column-Rentabilidad'
              ? element[column.ColumnDef] < 0
                ? 'red'
                : 'blue'
              : '',
            fontFamily:
              column.TextStyle == 'mat-column-Rentabilidad'
                ? 'Roboto-Bold'
                : '',
            width: column.size ? column.size : 'auto'
          }"
        >
          {{
            column.Pipe === pipe.datePipe
              ? (element[column.ColumnDef] | dateTablePipe)
              : column.Pipe === pipe.thousandPipe
              ? (element[column.ColumnDef] | number: '1.0-0')
              : column.Pipe === pipe.currencyCLPipe
              ? (element[column.ColumnDef] | currencyTablePipe)
              : column.Pipe === pipe.UFPipe
              ? (element[column.ColumnDef] | number: '1.2-4')
              : column.Pipe === pipe.decimalPipe
              ? (element[column.ColumnDef] | number)
              : column.Pipe === pipe.checkNumberPipe
              ? (element[column.ColumnDef] | checkNumberPipe)
              : column.Pipe === pipe.percentagePipe
              ? (element[column.ColumnDef] | percentageTablePipe)
              : column.Pipe === pipe.purePercentagePipe
              ? (element[column.ColumnDef] | purePercentageTablePipe)
              : column.Pipe === pipe.dateNombreMesPipe
              ? (element[column.ColumnDef] | dateNombreMesTablePipe)
              : column.Pipe === pipe.dateNombreMesPipe2
              ? (element[column.ColumnDef] | dateNombreMesTablePipe: 'MMM-YYYY')
              : column.Pipe === pipe.edadPipe
              ? (element[column.ColumnDef] | edadTablePipe)
              : element[column.ColumnDef]
          }}
        </td>
      </span>
      <td
        appTableFooterFormat
        [ngStyle]="{ width: column.size ? column.size : 'auto' }"
        [column]="column"
        mat-footer-cell
        *matFooterCellDef
        [ngClass]="[
          column.TextAlign ? column.TextAlign : '',
          column.TextStyle ? column.TextStyle : ''
        ]"
      >
        {{ getTotalCost(column) }}
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="disclaimer">
      <span *ngFor="let column of displayedColumns">
        <td mat-footer-cell *matFooterCellDef>
          {{column.Sum}}
        </td>
      </span>
    </ng-container> -->

    <ng-container matColumnDef="other-header">
      <th
        [ngStyle]="{ width: column.size ? column.size : 'auto' }"
        [colSpan]="displayedColumns?.length"
        mat-header-cell
        *matHeaderCellDef
        class="mat-cell-left"
        [ngClass]="
          theme === 0 ? 'mat-header-cell-light' : 'mat-header-cell-dark'
        "
      >
        {{ customHeader }}
      </th>
    </ng-container>

    <tr
      mat-header-row
      class="sticky-header"
      [ngStyle]="{ display: showHeader ? '' : 'none' }"
      *matHeaderRowDef="
        customHeader == '' ? displayedColumnsLabel : ['other-header'];
        sticky: datasource?.length > scrollRow ? true : false
      "
      [ngClass]="
        theme === 0
          ? ''
          : theme === 2
          ? 'background-footer-total'
          : theme === 3
          ? 'background-footer-saldo'
          : 'background-footer-light'
      "
    ></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsLabel"></tr>
    <span *ngIf="hasFooter">
      <!-- <tr mat-footer-row *matFooterRowDef="['disclaimer']" class="example-second-footer-row"></tr> -->
      <tr
        [ngClass]="
          theme === 0
            ? ''
            : theme === 2
            ? 'background-footer-total'
            : 'background-footer-light'
        "
        mat-footer-row
        class="mat-cell-right"
        *matFooterRowDef="displayedColumnsLabel"
      ></tr>
    </span>
  </table>

  <p *ngIf="message" class="vida-foot-message">&nbsp;{{ message }}</p>
  <app-paginator-custom
    *ngIf="visiblePaginator"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [length]="paginatorLength"
    ($onChangePage)="getDataPaginator($event)"
  ></app-paginator-custom>
</div>
